module.exports = __webpack_public_path__ + "static/media/clothing-fasion.fe277ea4.svg";